import {Pipe, PipeTransform} from '@angular/core';
import {TransactionTypeFilter} from './filters/transaction-type-filter';
import {DataSource} from '../portfolio-creation/manualinvest/data-source';
import {PassbookDateRangeFilter} from './filters/passbook-date-range.filter';

@Pipe({name: 'passbookDateRangeFilter'})
export class PassbookDateRangeFilterPipe implements PipeTransform {
    private readonly dateRangeFilter: PassbookDateRangeFilter;

    constructor(dateRangeFilter: PassbookDateRangeFilter) {
        this.dateRangeFilter = dateRangeFilter;
    }

    transform(dataSource: DataSource, query: any): any {
        return dataSource.applyFilter(this.dateRangeFilter, query);
    }
}

@Pipe({name: 'transactionTypeFilter'})
export class TransactionTypeFilterPipe implements PipeTransform {
    private readonly transactionTypeFilter: TransactionTypeFilter;

    constructor(transactionTypeFilter: TransactionTypeFilter) {
        this.transactionTypeFilter = transactionTypeFilter;
    }

    transform(dataSource: DataSource, query: any): any {
        return dataSource.applyFilter(this.transactionTypeFilter, query);
    }
}
